var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('vue-tel-input',{staticClass:"phone-input",attrs:{"mode":"international","defaultCountry":"us","placeholder":_vm.placeholder,"maxLen":"15","inputClasses":"phone-input-container"},on:{"input":_vm.updateValue}}),(_vm.error !== '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }